import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { GENERIC_ERROR_MESSAGE, logApiError, logUnexpectedError } from "../Utils/apiError";

export default function DealerLogin() {
  const navigate = useNavigate();
  const API = process.env.REACT_APP_API_BASE;

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState("");
  const [showPw, setShowPw] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    setLoading(true);
    try {
      const res = await fetch(`${API}/dealer/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email, password })
      });
      if (!res.ok) {
        await logApiError(res, "Dealer login failed");
        setErr(res.status === 401 ? "Invalid email or password." : GENERIC_ERROR_MESSAGE);
        return;
      }
      const data = await res.json();
      localStorage.setItem("dealerToken", data.token);
      navigate("/dealer/leads", { replace: true });
    } catch (e) {
      logUnexpectedError(e, "Dealer login request failed");
      setErr(GENERIC_ERROR_MESSAGE);
    } finally {
      setLoading(false);
    }
  };

  const forgotHref = `/dealer/forgot-password${email ? `?email=${encodeURIComponent(email)}` : ""}`;

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 px-4">
      <form onSubmit={submit} className="w-full max-w-sm bg-white p-6 rounded-xl border">
        <h1 className="text-2xl font-semibold">Dealer Login</h1>

        <div className="mt-4">
          <label className="block text-sm text-gray-700 mb-1">Work email</label>
          <input
            type="email"
            className="w-full border border-gray-300 rounded-lg px-3 py-2"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="you@dealerdomain.com"
            required
          />
        </div>

        <div className="mt-3">
          <div className="flex items-center justify-between">
            <label className="block text-sm text-gray-700 mb-1">Password</label>
          </div>
          <div className="relative">
            <input
              type={showPw ? "text" : "password"}
              className="w-full border border-gray-300 rounded-lg px-3 py-2 pr-10"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="********"
              required
            />
            <button
              type="button"
              onClick={() => setShowPw((s) => !s)}
              className="absolute inset-y-0 right-0 px-3 flex items-center text-gray-500 hover:text-gray-700"
              tabIndex={-1}
            >
              {showPw ? <FaEyeSlash /> : <FaEye />}
            </button>
          </div>
        </div>

        {err && <div className="text-red-600 text-sm mt-3">{err}</div>}

        <button
          type="submit"
          disabled={loading}
          className="mt-4 w-full bg-blue-600 text-white rounded-lg px-4 py-2 hover:bg-blue-700 disabled:opacity-50"
        >
          {loading ? "Signing in..." : "Sign in"}
        </button>

        <div className="mt-3 text-sm text-gray-600 text-center">
          Don&apos;t have access? Contact us for an invite.
        </div>
        <div className="mt-3 text-sm text-gray-600 text-center">
          <Link
            to={forgotHref}
            className="text-sm text-blue-600 hover:underline"
          >
            Forgot password?
          </Link>
        </div>
      </form>
    </div>
  );
}
